class SearchTabsComponent extends HTMLElement {
  constructor() {
    super();
    this.tabNavItems = this.querySelectorAll('[data-vf-search-tabs-nav-item]');
    this.searchResultsContainer = document.getElementById('search-results-container');
  }

  connectedCallback() {
    // get the search terms from the url
    const searchTerms = new URLSearchParams(window.location.search).get('q');
    this.searchTerms = searchTerms;
    this.tabNavItems.forEach(item => {
      item.addEventListener('click', this.handleTabNavItemClick.bind(this));
    });

    this.setResultsCounts();
  }

  handleTabNavItemClick(event) {
    const searchType = event.currentTarget.dataset.searchType.replaceAll('_', ',');
    const request = new XMLHttpRequest();
    request.addEventListener('load', (event) => {
      try {
        this.handleSearchResultsResponse(event);
      } catch (error) {
        console.error('Error rendering search results', error);
      }
    });
    request.open('GET', `${window.location.pathname}?sections=search-results&q=${this.searchTerms}&type=${searchType}`, true);
    request.send();

    this.tabNavItems.forEach(item => {
      item.classList.remove('active');
      item.classList.add('loading');
    });
    event.currentTarget.classList.add('active');
  }

  handleSearchResultsResponse(event) {
    const searchResults = JSON.parse(event.target.response)['search-results'];
    const html = new DOMParser().parseFromString(searchResults, 'text/html');
    this.searchResultsContainer.innerHTML = html.querySelector('#search-results').innerHTML;
    this.tabNavItems.forEach(item => {
      item.classList.remove('loading');
    });
  }

  setResultsCounts() {
    this.tabNavItems.forEach(item => {
      const searchType = item.dataset.searchType.replaceAll('_', ',');
      const request = new XMLHttpRequest();
      request.addEventListener('load', (event) => {
        try {
          this.handleSearchResultsCountResponse(event, item);
        } catch (error) {
          console.error('Error rendering search results', error);
        }
      });
      request.open('GET', `${window.location.pathname}?sections=search-results-count&q=${this.searchTerms}&type=${searchType}`, true);
      request.send();
    });
  }

  handleSearchResultsCountResponse(event, item) {
    const searchResultsCount = JSON.parse(event.target.response)['search-results-count'];
    const html = new DOMParser().parseFromString(searchResultsCount, 'text/html');
    const resultsCount = item.querySelector('[data-results-count]');
    resultsCount.innerHTML = html.querySelector('#search-results-count').innerHTML;
    if (resultsCount.innerHTML == '0') {
      item.disabled = true;
    } else {
      item.disabled = false;
    }
  }
}

customElements.define('search-tabs-component', SearchTabsComponent);